import {ConfirmationModal} from './ConfirmationModal'
import {useConfirmDialogStore} from '../store/confirmDialogStore'

/**
 * Mounted once at the app root (see App.tsx, next to <ToastContainer />). Renders
 * whatever confirmDialog()/confirmDelete() from `store/confirmDialogStore` requested —
 * callers never need to render or wire up a modal themselves.
 */
export const ConfirmDialogHost: React.FC = () => {
  const {isOpen, title, message, confirmText, cancelText, variant, icon, resolve, close} =
    useConfirmDialogStore()

  const handleConfirm = () => {
    resolve?.(true)
    close()
  }

  const handleCancel = () => {
    resolve?.(false)
    close()
  }

  return (
    <ConfirmationModal
      show={isOpen}
      onHide={handleCancel}
      onConfirm={handleConfirm}
      title={title || 'Confirm'}
      message={message}
      confirmText={confirmText}
      cancelText={cancelText}
      variant={variant}
      icon={icon}
    />
  )
}
